<template>
  <v-sheet
    class="left-toolbar modern-glass-toolbar d-flex flex-column align-center py-2"
    elevation="4"
    rounded="lg"
  >
    <template v-for="(item, index) in tools">
      <v-divider v-if="item.divider" :key="'divider-' + index" class="my-1 full-width" />
      
      <v-tooltip v-else :key="item.id" right>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            class="my-1 tool-btn"
            :class="{ 'active-tool': activeTools.includes(item.id) }"
            :color="activeTools.includes(item.id) ? 'primary' : '#64748b'"
            v-bind="attrs"
            v-on="on"
            @click="emitClick(item.id)"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </template>
  </v-sheet>
</template>

<script>
export default {
  name: 'MapShareLeftToolbar',
  props: {
    activeTools: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tools: [
        { id: 'layer', title: 'Quản lý lớp bản đồ', icon: 'mdi-layers' },
        { id: 'legend', title: 'Bảng chú giải', icon: 'mdi-format-list-bulleted-type' },
        { id: 'identify', title: 'Xem thông tin đối tượng', icon: 'mdi-information-outline' },
        { id: 'statistic', title: 'Thống kê dữ liệu', icon: 'mdi-chart-pie' },
        { divider: true },
        { id: 'distance', title: 'Đo chiều dài', icon: 'mdi-ruler' },
        { id: 'azimuth', title: 'Đo phương vị', icon: 'mdi-table-headers-eye' },
        { id: 'area', title: 'Đo diện tích', icon: 'mdi-ruler-square-compass' },
        { divider: true },
        { id: 'print', title: 'In bản đồ', icon: 'mdi-printer-outline' },
      ]
    }
  },
  methods: {
    emitClick(btnName) {
      this.$emit(`click-${btnName}`);
    }
  }
}
</script>

<style scoped>
.left-toolbar {
  position: absolute;
  top: 96px;
  left: 24px;
  width: 48px;
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  z-index: 100;
}
.full-width {
  width: 80%;
}
.tool-btn {
  transition: all 0.2s ease-in-out;
}
.active-tool {
  background-color: rgba(25, 118, 210, 0.15) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.4) !important;
  border-radius: 10px !important;
}
</style>
